<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">ASL</label>
                        <b-form-select v-model="filtro.codiceAslAutore" :options="opzioniAsl"></b-form-select>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice PAI</label>
                        <b-form-input v-model="filtro.idPai" type="search" placeholder="idPai"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Assistito</label>
                        <b-form-input v-model="filtro.assistito" type="search" placeholder="Nome, cognome o Codice Fiscale"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">Cerca</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">Reset Filtro</b-button>
                        <b-button variant="outline-info" @click="onClickSincronizza">
                            <i class="fas fa-cloud-download-alt"></i>
                            Aggiorna da AnDIamo
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(nominativo)="{ item }">
                        <router-link class="sa-edit-link" :to="{ path: '/andiamo/pai/' + item.idPai, query: { codiceAsl: filtro.codiceAslAutore } }">{{ item.cognomeAssistito }} {{ item.nomeAssistito }}</router-link>
                        <div class="small text-muted">CF: {{ item.codiceFiscaleAssistito || "-" }}</div>
                    </template>
                    <template v-slot:cell(idPai)="{ item }">#{{ item.idPai }}</template>
                    <template v-slot:cell(status)="{ item }">
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (item.status === 'active' ? 'aperta' : 'da-programmare')">{{ item.status || "-" }}</span>
                    </template>
                    <template v-slot:cell(periodEnd)="{ item }">{{ item.periodEnd ? formatDate(item.periodEnd) : "-" }}</template>
                    <template v-slot:cell(eventiDaLeggere)="{ item }">
                        <span v-if="item.eventiDaLeggere > 0" class="badge badge-pill badge-warning">{{ item.eventiDaLeggere }} da leggere</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <router-link :to="{ path: '/andiamo/pai/' + item.idPai, query: { codiceAsl: filtro.codiceAslAutore } }" class="btn btn-sm btn-outline-secondary">
                            <i class="fas fa-eye"></i>
                            Vedi
                        </router-link>
                    </template>
                </b-table>
            </div>
        </template>
        <template slot="table-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Totale Record: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AndiamoMixin from "../mixins/AndiamoMixin";

export default {
    components: { SaPageLayout },
    mixins: [UtilityMixin, AndiamoMixin],
    data() {
        return {
            rows: 0,
            perPage: 2000,
            currentPage: 1,
            showModalLoading: false,
            items: [],
            opzioniAsl: [
                // { value: null, text: "Tutte" },
                { value: "150204", text: "150204" },
                { value: "150205", text: "150205" },
                { value: "150206", text: "150206" },
            ],
            filtro: { codiceAslAutore: "150205", idPai: null, assistito: null },
            fields: [
                { label: "Assistito", key: "nominativo" },
                { label: "PAI", key: "idPai", sortable: true },
                { label: "Stato", key: "status" },
                { label: "Scadenza", key: "periodEnd" },
                { label: "Eventi", key: "eventiDaLeggere" },
                { label: "", key: "actions", tdClass: "sa-table-column-action-double" },
            ],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.andiamoPaiRiepilogoPathResource;
            let params = { ...me.filtro, page: me.currentPage, forPage: me.perPage };
            axios
                .get(link, { params: params })
                .then((response) => {
                    me.items = response.data.data.list || [];
                    me.rows = response.data.data.recordsNumber || 0;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onSubmit() {
            this.currentPage = 1;
            this.loadData();
        },
        onReset() {
            this.filtro = { codiceAslAutore: "150205", idPai: null, assistito: null };
            this.currentPage = 1;
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        onClickSincronizza() {
            if (!this.filtro.codiceAslAutore) {
                this.$bvToast.toast("Seleziona il codice ASL prima di sincronizzare", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + this.andiamoPaiPathResource;
            axios
                .get(link, { params: { codiceAsl: this.filtro.codiceAslAutore, soloNonLetti: true } })
                .then(() => {
                    this.showModalLoading = false;
                    this.$bvToast.toast("PAI aggiornati da AnDIamo", { title: "", variant: "success", solid: true });
                    this.loadData();
                })
                .catch((error) => {
                    this.showModalLoading = false;
                    this.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
    },
};
</script>

<style scoped>
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
